// Control IDs for the Hospital reports page (sai's hospital IDs, mapped to ours
// by toTrapezium: hospital.* -> product.hospital-reports.*). Its steps and Next
// come from sai/ids.js.
import { toTrapezium as t } from './sai/trapezium';

export const IDS = {
  doc: (k) => t(`hospital.doc-${k}`), // discharge (4 steps) | rx (1 step, its tab rendered by HospitalReports)
};
